require('./RACommissionTag.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @utilities
const { FormattedText } = require('core/i18n').i18n;
const { formatPercentage } = require('../../utilities/RACurrencyHelper');

class RACommissionTag extends React.Component {
    render() {
        const { showZeroPercentage, hideMessage } = this.props;

        let message;
        if (!hideMessage) {
            message = (
                <div className="ra-commission-tag__wrapper">
                    <FormattedText
                        className="ra-commission-tag__label no-print-out"
                        value="raCommissionTag-raCommissionTag_label"
                    />
                    {showZeroPercentage ? (
                        <span className="ra-commission-tag__percentage">
                            {formatPercentage(0)}
                        </span>
                    ) : null}
                </div>
            );
        }

        return <div className="ra-commission-tag">{message}</div>;
    }
}

RACommissionTag.propTypes = {
    showZeroPercentage: PropTypes.bool,
    hideMessage: PropTypes.bool,
};

RACommissionTag.defaultProps = {
    showZeroPercentage: false,
    hideMessage: false,
};

module.exports = RACommissionTag;
